import { useMemo } from "react";

import { useUnsafeCurrentViewContext } from "../../hooks/use-current-view-context";
import { useDatatableContext } from "../datatable/use-datatable-context";

import { computeHasUnsavedChanges } from "./compute-has-unsaved-changes";
import { useStoredViewMenuContext } from "./stored-view-menu-context";

export const useHasUnsavedStoredView = (): { hasUnsavedChanges: boolean } => {
  const { localStoredViewId } = useStoredViewMenuContext();
  const currentViewContext = useUnsafeCurrentViewContext();
  const { state: localDatatableState, columns } = useDatatableContext();

  const validColumnIdSet = useMemo(() => new Set(columns.map((column) => column.columnId)), [columns]);

  const hasUnsavedChanges = useMemo(
    () => computeHasUnsavedChanges({ localDatatableState, currentViewContext, localStoredViewId, validColumnIdSet }),
    [localDatatableState, currentViewContext, validColumnIdSet, localStoredViewId],
  );

  return { hasUnsavedChanges };
};
